/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../app/components/export-documents/form-input-errors.component';
const styles_FormInputErrorsComponent:any[] = ([] as any[]);
export const RenderType_FormInputErrorsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormInputErrorsComponent,data:{}});
function View_FormInputErrorsComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'help-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.inputField.Errors[0];
    _ck(_v,1,0,currVal_0);
  });
}
export function View_FormInputErrorsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_FormInputErrorsComponent_1)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i2.FormInputErrorsComponent = _v.component;
    const currVal_0:boolean = !_co.inputField.IsValid;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_FormInputErrorsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'form-input-errors',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormInputErrorsComponent_0,
      RenderType_FormInputErrorsComponent)),i0.ɵdid(49152,(null as any),0,i2.FormInputErrorsComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FormInputErrorsComponentNgFactory:i0.ComponentFactory<i2.FormInputErrorsComponent> = i0.ɵccf('form-input-errors',
    i2.FormInputErrorsComponent,View_FormInputErrorsComponent_Host_0,{inputField:'inputField'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9leHBvcnQtZG9jdW1lbnRzL2Zvcm0taW5wdXQtZXJyb3JzLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvZXhwb3J0LWRvY3VtZW50cy9mb3JtLWlucHV0LWVycm9ycy5jb21wb25lbnQudHMuRm9ybUlucHV0RXJyb3JzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNwYW4gY2xhc3M9XCJoZWxwLWJsb2NrXCIgKm5nSWY9XCIhaW5wdXRGaWVsZC5Jc1ZhbGlkXCI+e3tpbnB1dEZpZWxkLkVycm9yc1swXX19PC9zcGFuPiIsIjxmb3JtLWlucHV0LWVycm9ycz48L2Zvcm0taW5wdXQtZXJyb3JzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQXFEOztJQUFBO0lBQUE7Ozs7b0JBQXJEO01BQUEseUNBQUE7b0JBQUE7O0lBQXlCO0lBQXpCLFdBQXlCLFNBQXpCOzs7O29CQ0FBO01BQUE7eUNBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./compiled/app/components/export-documents/form-input-errors.component.ngfactory.ts